module.exports = __webpack_public_path__ + "static/img/009.295870f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/009.png
// module id = JBZw
// module chunks = 1